<template>
  <div>
    <v-progress-linear v-if="loading" indeterminate></v-progress-linear>

    <div v-if="!loading && goals.length > 0" class="goals-list">
      <div v-for="goal in goals" :key="goal.id" class="goal">
        <div>
          <v-icon small color="contrast">mdi-bullseye-arrow</v-icon>
          {{ goal.description }}
        </div>
        <v-spacer></v-spacer>
        <div class="actions">
          <v-btn color="primary" @click="openEditModal(goal)" variant="text">
            <v-icon left>mdi-pencil</v-icon>
            Edit
          </v-btn>
          <v-btn color="error" @click="deleteGoal(goal.id)" variant="text">
            <v-icon left>mdi-delete</v-icon>
            Delete
          </v-btn>
        </div>
      </div>
    </div>

    <div v-else-if="!loading && goals.length === 0" class="no-goals">
      No goals found for this problem.
    </div>
  </div>
</template>

<script>
import apiClient from "@/plugins/apiService";

export default {
  props: {
    goals: {
      type: Array,
      required: true,
    },
    selectedProblem: {
      type: [String, Number],
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    saveGoal(goal) {
      if (goal.description.trim()) {
        apiClient
          .put(`/goal/${goal.id}`, {
            description: goal.description,
          })
          .then((response) => {
            if (response.status === 200) {
              this.$emit("goal-updated");
            }
          });
      }
    },
    deleteGoal(goalId) {
      apiClient.delete(`/goal/${goalId}`).then((response) => {
        if (response.status === 200) {
          this.$emit("goal-deleted");
        }
      });
    },
    openEditModal(goal) {
      this.$emit("edit-goal", goal);
    },
  },
};
</script>

<style scoped>
.goals-list {
  display: flex;
  color: var(--contrastColor);
  flex-direction: column;
  max-height: 400px;
  overflow-y: auto;
}

.goal {
  display: flex;
  align-items: self-start;
  border-bottom: 1px solid var(--contrastColor);
  padding: 12px 0;
}

.actions {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-top: 12px;
}

.no-goals {
  font-style: italic;
}
</style>
